export default "__VITE_ASSET__Rt0Nt7cP__"